import { Ruler, ArrowLeftRight, ArrowDown, ArrowUpRight, MoveDiagonal, Sigma } from "lucide-react";

interface LinearMeasurementsProps {
  ridge: number;
  eave: number;
  rake: number;
  hip: number;
  valley: number;
  stepFlash?: number;
  apron?: number;
}

export function LinearMeasurements({ ridge, eave, rake, hip, valley, stepFlash = 0, apron = 0 }: LinearMeasurementsProps) {
  const total = ridge + eave + rake + hip + valley + stepFlash + apron;
  const items = [
    { label: "Ridge", value: ridge, segs: 3, icon: ArrowLeftRight },
    { label: "Eave", value: eave, segs: 5, icon: ArrowDown },
    { label: "Rake", value: rake, segs: 5, icon: ArrowUpRight },
    { label: "Hip", value: hip, segs: 4, icon: MoveDiagonal },
    { label: "Valley", value: valley, segs: 3, icon: MoveDiagonal },
    { label: "Step Flash", value: stepFlash, segs: 4, icon: Ruler },
    { label: "Apron", value: apron, segs: 3, icon: Ruler },
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold flex items-center gap-2">
        <Ruler className="w-4 h-4 text-primary" /> Linear Measurements
      </h3>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        {items.map((it) => (
          <div key={it.label} className="min-w-0 rounded-xl border border-border bg-card p-3">
            <div className="flex items-center justify-between mb-1">
              <it.icon className="w-3.5 h-3.5 text-muted-foreground" />
              <span className="text-[10px] text-muted-foreground">{it.segs} segs</span>
            </div>
            <div className="text-xl font-bold">{Math.round(it.value)}'</div>
            <div className="break-words text-xs text-muted-foreground">{it.label}</div>
          </div>
        ))}
        <div className="min-w-0 rounded-xl border border-destructive/20 bg-destructive/5 p-3">
          <div className="flex items-center justify-between mb-1">
            <Sigma className="w-3.5 h-3.5 text-destructive" />
            <span className="text-[10px] text-muted-foreground">total</span>
          </div>
          <div className="text-xl font-bold text-destructive">{Math.round(total)}'</div>
          <div className="text-xs text-muted-foreground">Total</div>
        </div>
      </div>
    </div>
  );
}
